import { CARAVAGGIO_STORY } from './caravaggio';
import { WOMAN_STORY } from './woman';
import { MUSIC_STORY } from './music';

export const STORIES = [
    CARAVAGGIO_STORY,
    WOMAN_STORY,
    MUSIC_STORY
  ];